import { FunctionComponent } from 'react';
import { useDispatch } from '@cbridge-utils/react-redux';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { DetailsSidebarViewControls } from '../DetailsSidebarViewControls/DetailsSidebarViewControls';

export const DefaultDetailsSidebarViewControls: FunctionComponent = () => {
  const dispatch = useDispatch();

  const handleEdit = () => {
    dispatch(DetailsSidebarAction.toggleEdit());
  };

  return <DetailsSidebarViewControls onEdit={handleEdit} />;
};
